module.exports = __webpack_public_path__ + "static/media/ΛΑΓΟΣ ΧΕΛΩΝΑ (ΑΝΓ).6f40ba06.vtt";